import { DropdownDirections } from '@anm/components/Dropdown';
import { MY_VIDEOS_HEADER_HEIGHT } from '@anm/styles/constants';
import { useEffect, useRef, useState } from 'react';

const ACTION_ITEM_HEIGHT = 45;
const ACTIONS_CONTENT_VERTICAL_GAPS = 29;
const HEADER_HEIGHT_NUMBER = +MY_VIDEOS_HEADER_HEIGHT.split('px')[0];

export const useDropdownDirection = (actionsLength: number) => {
  const [direction, setDirection] = useState<DropdownDirections>('to-bottom-right');
  const dropdownButtonRef = useRef<HTMLDivElement>(null);
  const dropdownButtonBounding = dropdownButtonRef?.current?.getBoundingClientRect();
  const dropdownContentHeight = actionsLength * ACTION_ITEM_HEIGHT + ACTIONS_CONTENT_VERTICAL_GAPS;

  dropdownContentHeight;

  useEffect(() => {
    if (!dropdownButtonBounding) return;

    const distanceToTop = dropdownButtonBounding?.top - HEADER_HEIGHT_NUMBER;
    const distanceToBottom = window.innerHeight - dropdownButtonBounding.bottom;

    const canOpenToTop =
      !(!window.scrollY && distanceToTop < dropdownContentHeight) && distanceToTop > distanceToBottom;

    const newDirection = canOpenToTop ? 'to-top' : 'to-bottom-right';

    setDirection(newDirection);
  }, [dropdownButtonBounding?.top]);

  return [dropdownButtonRef, direction] as const;
};
